/** Founder-ratified booking page (7 Sep). Direct link; not the demo calendar. */
export const APPOINTMENT_URL = 'https://calendar.app.google/QfxzbNEejLnwudC49';
